import { useEffect, useRef } from "react";

// Lightweight scroll-reveal hook using IntersectionObserver.
// Any element with className "reveal" inside the tree will fade/rise in.
export function useScrollReveal(deps = []) {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current || document;
    const nodes = root.querySelectorAll(".reveal");
    if (!nodes.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    nodes.forEach((n, i) => {
      n.style.transitionDelay = `${Math.min(i * 60, 240)}ms`;
      io.observe(n);
    });

    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return rootRef;
}
